const headerMapFields = {
  'Depot Reference ID': 'depot_reference_id',
  Movement: 'movement',
  'Extra Drop Off Charge': 'extra_drop_off_charge',
};

module.exports = {
  headerMapFields,
};
